import React, { useState, useEffect } from "react"
import _get from "lodash/get"
import { useSelector } from "react-redux"
import {
  getUserPersona,
  sanitizeTextForAnalytics,
  getCurrentSkuCouponDiscounts,
} from "@/utils/helper"
import { getConfig } from "@/constants/config"
import ImageTile from "@/components/MyFavorites/v1/ImageTile"
import ProductTile from "@/components/MyFavorites/v1/ProductTile"
import VideoTile from "@/components/MyFavorites/v1/VideoTile"
import ArticleTile from "@/components/MyFavorites/v1/ArticleTile"

import favAddIcon from "@/public/icons/fav-add.svg"
import favTickIcon from "@/public/icons/fav-tick.svg"

const FavoritesTile = props => {
  const {
    fid = "",
    data = {},
    editMode = false,
    isSelected = false,
    locale = "",
    onSelect = () => {},
    selectedtab = "",
    isAuth = false,
    user = {},
    staticTexts = {},
    presetConfigs = "",
    smartCrop = {},
    isGrouped = false,
    exactSKU = false,
    mapImageToColor,
    currFilters = [],
    type = "",
    swatchCount = 0,
    index = 0,
    brandSwitcherItems = [],
  } = props

  const selected = isSelected(fid)

  const { custom: { fields: { itemType = "", link = "" } = {} } = {} } = data

  const persona = getUserPersona()
  const cartData = useSelector(state => state?.cart?.data)

  const [siteName, setSiteName] = useState()

  useEffect(() => {
    getConfig().then(config => {
      const brandName = _get(config, "general.siteName")
      setSiteName(brandName)
    })
  }, [])

  const {
    productData = {},
    name = {},
    variant: { attributes = [] } = {},
  } = data

  const sku = exactSKU ? exactSKU : data?.variant?.sku ?? ""

  if (mapImageToColor && currFilters) {
    const colorFilter = currFilters?.find(
      q =>
        q.facet === "Color.Finish" ||
        q.facet === "Color" ||
        q.facet === "Finish"
    )
    const selColors = colorFilter?.value
    if (selColors?.length > 0) {
      let selectedProductImage = ""
      let i = selColors?.length - 1 ?? 0
      while (!selectedProductImage && i >= 0) {
        const colorName = selColors[i]
        if (productData[`Color.${persona}.Details_ss`]) {
          const exactSKUDetails =
            productData[`Color.${persona}.Details_ss`]
              .find(item => item.split("|")[1] === colorName)
              ?.split("|") ?? []
          const productId =
            exactSKUDetails[5]?.split("?")[0].split("/").slice(-1) ?? []
          selectedProductImage = productId[0] ?? ""
        }
        i--
      }

      if (!selectedProductImage) selectedProductImage = "MissingImage"
      if (images[0] === images[1]) {
        images = [selectedProductImage, selectedProductImage]
      } else {
        images[0] = selectedProductImage
      }
    }
  }

  let colors = []
  let images = []
  if (productData["Color.SKU.Details_ss"]) {
    colors = productData["Color.SKU.Details_ss"]?.map(color => {
      const d = color?.split("|")
      return {
        name: d[0],
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        isDiscontinued: d[4],
        customerFacingSKU: d[5],
      }
    })
  }

  colors = colors?.filter(
    item =>
      item.isDiscontinued === "false" ||
      Date.parse(item.isDiscontinued) > Date.now()
  )

  const {
    Collapse_Title_s: collapseTitles = "",
    productName_s: productNames = "",
    RegionBrandName_s: regionBrandNames = "",
    ProductBrandName_s: productBrandNames = "",
    Tile_Title: tileTitle,
    Collapse_Description_s: collapseDescriptions = "",
    ProductDescriptionProductShort_s: productDescriptionProductShorts = "",
    Product_Category: productCategory = "",
    ProductLocalCategory_s: productLocalCategorys = "",
  } = productData

  const productLocaleName = name[locale]

  const isBundleProduct = Boolean(
    attributes.find(e => e.name === "primaryProduct")
  )

  const itemName = isGrouped
    ? collapseTitles
    : type === "parts"
    ? productNames
    : regionBrandNames || productBrandNames

  const productName = isBundleProduct ? productLocaleName : itemName

  const description = isGrouped
    ? collapseDescriptions
    : productDescriptionProductShorts

  const category = productCategory ? productCategory : productLocalCategorys

  const badgeVal = _get(productData, `priceList.${persona}.saleOffer_s`, "")

  const discountedPrice = _get(
    productData,
    `priceList.${persona}.finalPrice_d`,
    0
  )

  const price = _get(productData, `priceStartingAt.${persona}_d`, 0)

  const isDiscountedPrice = _get(
    productData,
    `priceList.${persona}.discountedPrice_d`,
    0
  )

  const detaultSelectedColor = colors.length ? colors[0]?.name : ""
  const defaultCustomerFacingSku = colors.length
    ? colors[0]?.customerFacingSKU
    : ""

  const defaultImage = images.length ? images[0] : ""
  const defaultProductIsInStock = colors.length
    ? colors[0].isStock === "true" || colors[0].isStock === true
    : false

  const discountPercent =
    badgeVal && isDiscountedPrice
      ? 100 - Math.round((isDiscountedPrice / price) * 100)
      : 0

  const discountPriceState =
    badgeVal && isDiscountedPrice
      ? "percentOff|" + discountPercent
      : "regular price"
  const productIsRetail =
    _get(productData, "ProductIsRetail", "") === "true" ? true : false
  const isSuperSku = _get(productData, "comboSKUAvailable_b", null)
    ? true
    : false
  const discountAmount = discountPercent
    ? Number((price - isDiscountedPrice).toFixed(2))
    : 0
  const productSaleable = productIsRetail || !colors.length ? false : true
  const productRoom = _get(productData, "category1_s", "n/a")
  const productCollectionsName = _get(
    productData,
    "ProductBrandNameDisplay_s",
    "n/a"
  )

  const getEventInfo = () => {
    const type = selected ? "select" : "unselect"
    const eventInfo = {
      eventAction: `my account:favorites:${selectedtab.toLowerCase()}:${type}`,
      eventName: `my account:favorites:${selectedtab.toLowerCase()}:${type}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: type,
      internalLinkPosition: "favorites",
      internalLinkType: `my account:${type}`,
      internalLinkZoneName: `my account:favorites:${selectedtab.toLowerCase()}`,
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
    return JSON.stringify(eventInfo)
  }

  const getProductInfo = (color, needsJSON = false) => {
    const { productCouponCode, productCoupondiscount } =
      getCurrentSkuCouponDiscounts({ cart: cartData, sku: sku })
    const productInfo = {
      productInfo: {
        productBrand: siteName?.siteName?.toLowerCase(),
        description: sanitizeTextForAnalytics(description) || "n/a",
        globalPromotionPrice:
          discountPercent && discountAmount
            ? Number((price - discountAmount).toFixed(2))
            : price,
        priceState: discountPriceState,
        productBasePrice: price,
        productCategory: sanitizeTextForAnalytics(category) || "n/a",
        productColor:
          sanitizeTextForAnalytics(color ? color.name : detaultSelectedColor) ||
          "n/a",
        productID:
          (color ? color.customerFacingSKU : defaultCustomerFacingSku) || "n/a",
        productName: sanitizeTextForAnalytics(productName) || "n/a",
        productRoom: sanitizeTextForAnalytics(productRoom || category) || "n/a",
        productSalePrice: discountedPrice ? discountedPrice : price,
        productSaleable: productSaleable,
        productStatus: color
          ? color.isStock === "true" || color.isStock === true
            ? "in stock"
            : "out of stock"
          : defaultProductIsInStock
          ? "in stock"
          : "out of stock",
        productSuperSku: isSuperSku,
        productTileName: sanitizeTextForAnalytics(tileTitle) || "n/a",
        defaultImageName: defaultImage || "n/a",
        productCollectionsName:
          sanitizeTextForAnalytics(productCollectionsName || category) || "n/a",
        globalOffer: badgeVal ? badgeVal : "n/a",
        globalDiscount: discountPercent ? discountAmount : "n/a",
        productPartnerBuyNow: productIsRetail,
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCouponCode: productCouponCode.join("|") || "n/a",
        productCoupondiscount: productCoupondiscount,
        frequency: "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        quantity: "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
      },
    }
    if (needsJSON) {
      return productInfo.productInfo
    }
    return JSON.stringify(productInfo)
  }

  const productTileData = {
    ...data?.productData,
    productLocaleName,
    isBundleProduct,
  }

  return (
    <div
      className={`edit-wrapper item ${
        editMode && selected ? "--selected" : ""
      } ${"myfavorite-imagetile"} ${"myfavorite-videotile"} ${"myfavorite-producttile"}`}
      role="listitem"
    >
      {editMode && (
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        <a
          className="icon-select gbh-data-layer"
          role="button"
          tabIndex="0"
          aria-selected={selected}
          data-gbh-data-layer={getEventInfo()}
          data-gbh-data-layer-custom={getProductInfo()}
          onClick={() => onSelect(fid)}
        >
          <img
            role="presentation"
            src={selected ? favTickIcon?.src : favAddIcon?.src}
            alt=""
          />
        </a>
      )}
      {itemType === "image" && (
        <ImageTile
          key={link}
          url={link}
          altText={data.name[locale]}
          smartCrop={smartCrop}
        />
      )}
      {itemType === "video" && <VideoTile key={link} url={link} data={data} />}
      {itemType === "article" && <ArticleTile data={data} locale={locale} />}

      {data?.productId && (
        <ProductTile
          index={index}
          data={productTileData}
          hideCompare={true}
          isAuth={isAuth}
          user={user}
          staticTexts={staticTexts}
          swatchCount={swatchCount}
          presetConfigs={presetConfigs}
          selectedtab={selectedtab}
          isFavoriteVariant
          isVariantSku={data?.variant}
          brandSwitcherItems={brandSwitcherItems}
        />
      )}
    </div>
  )
}

export default FavoritesTile
